import React, { useCallback, useContext, useEffect, useState } from "react";
import { INIT_FILTER_STATE } from "../../../constants/driveglobalfilterinitialstates_coral";
// import { INIT_FILTER_STATE_DRIVE_ACE } from "../../../constants/driveglobalfilterinitalstates";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitialstates_coral";
import useHttp from "../../../hook/use-http";
import Filter_Coral from "./Filter_Coral";
import Topkpis_Coral from "./Topkpis_Coral";
import PageSecond_Coral from "./PageSecond_Coral";
import TwoChartTemplate_Coral from "./TwoChartTemplate_Coral";
import SingleSoc_Coral from "./SingleSoc_Coral";
import SinglePie_Coral from "./SinglePie_Coral";
import DischargeDuration_Coral from "./DischargeDuration_Coral";
import RpmVsThrottle_Coral from "./RpmVsThrottle_Coral";
import RegenPercent_Coral from "./RegenPercent_Coral";
import IdlePercent_Coral from "./IdlePercent_Coral";
import BcsActiveTime_Coral from "./BcsActiveTime_Coral";
import DashboardMain_Coral from "../DashboardMain_Coral/DashboardMain_Coral";
import "./Driveanalysis_Coral.css";
import WaterMark from "../DashboardMain_Coral/WaterMark";
import AppContext from "../../../store/AppContext";

import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";
import TableSection_Coral from "./TableSection_Coral";
import NetEnergyErc_Coral from "./NetEnergyErc_Coral";
import RangeErc_Coral from "./RangeErc_Coral";
import SingleSocErc_Coral from "./SingleSocErc_Coral";
import PageSecondErc_Coral from "./SecondPageErc_Coral/PageSecondErc_Coral";
import PieChartSocErc_Coral from "./RegenModeUsage";


function Driveanalysis_Coral() {
  const [gloablfilter, setGloablfilter] = useState(INIT_FILTER_STATE);
  // const [gloablfilter, setGloablfilter] = useState(INIT_FILTER_STATE_DRIVE_ACE);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const app_ctx = useContext(AppContext);

  const log_data = (data) => { };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "auth/logging",
        body: {
          page_name: "driveanalysis",
        },
      },
      log_data
    );
  }, []);

  const filterSubmited = useCallback((data) => {
    setGloablfilter(data);
  }, []);

  const singleVinSelected = (vin) => {
    let vin_num = vin.split(",");
    setGloablfilter((prevdata) => {
      return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 };
    });
  };

  const pageChange = () => {
    setGloablfilter((prevdata) => {
      return { ...prevdata, pageSelected: 1, VIN_NUM: [] };
    });
  };

  const onreset = (data) => {
    setGloablfilter(data);
  };

  const loggedInUser = useSelector(selectLoggedInUser);
  if (gloablfilter.pageSelected === 1) {
    return (
      <>
        <DashboardMain_Coral>
          <div
            className={
              (loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                ? "new_drive_dashboard"
                : "drive_dashboard"
            }
          >
            <Filter_Coral
              onsubmit={filterSubmited}
              gloablfilter={gloablfilter}
              onreset={onreset}
            />
            <div className="container-fluid">
              <Topkpis_Coral gloablfilter={gloablfilter} />
              {(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") && (
                <TableSection_Coral
                  singleVinSelected={singleVinSelected}
                  gloablfilter={gloablfilter}
                />
              )}
              <section className="graphs">
                <div className="row">
                  {/* {loggedInUser.flagForHideShow === "ERC" && (
                    <div className="col-md-12 col-sm-12 col-lg-3 mb-3">
                      <div id="wrapper" className="toggled">
                        <div id="page-content-wrapper">
                          <TopFiveSection
                            singleVinSelected={singleVinSelected}
                            gloablfilter={gloablfilter}
                          ></TopFiveSection>
                        </div>
                      </div>
                    </div>
                  )} */}
                  <div
                    className={
                      "col-md-12 col-sm-12 " +
                      ((loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV")
                        ? "col-lg-12"
                        : "col-lg-12")
                    }
                  >
                    <div className="row mb-3">
                      {!(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") && (
                        <>
                          <div className="col-md-12 col-sm-12 col-lg-6">
                            <TwoChartTemplate_Coral
                              title="Real World Range Distribution"
                              type="RANGE"
                              gloablfilter={gloablfilter}
                            ></TwoChartTemplate_Coral>
                          </div>
                          <div className="col-md-12 col-sm-12 col-lg-6">
                            <TwoChartTemplate_Coral
                              title="Net Energy consumption"
                              type="ENERGY"
                              gloablfilter={gloablfilter}
                            ></TwoChartTemplate_Coral>
                          </div>
                        </>
                      )}

                      {(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") && (
                        <>
                          <div className="col-md-6 col-sm-12 col-lg-4 drive_graph ">
                            <WaterMark />
                            <RangeErc_Coral
                              title="Real World Range Distribution"
                              gloablfilter={gloablfilter}
                              apiend="rangebarchart_erc"
                            ></RangeErc_Coral>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-4 drive_graph ">
                            <WaterMark />
                            <NetEnergyErc_Coral
                              title="Net Energy Consumption"
                              gloablfilter={gloablfilter}
                              apiend="energybarchart_erc"
                            ></NetEnergyErc_Coral>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-4 drive_graph ">
                            <WaterMark />
                            <SingleSocErc_Coral
                              title="SoC Discharge/Cycle "
                              gloablfilter={gloablfilter}
                              apiend="socbar_erc"
                            ></SingleSocErc_Coral>
                          </div>

                        </>
                      )}
                    </div>

                    <div className="row mb-3 equal-cols">
                      {!(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") && (
                        <>
                          <div className="col-md-6 col-sm-12 col-lg-6 drive_graph">
                            <WaterMark />
                            <SingleSoc_Coral
                              title="SoC Discharge/Cycle Analysis"
                              gloablfilter={gloablfilter}
                              apiend="socbar"
                            ></SingleSoc_Coral>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-6">
                            <WaterMark />
                            <SinglePie_Coral
                              title="Mode utilization"
                              gloablfilter={gloablfilter}
                              apiend="piechart"
                            ></SinglePie_Coral>
                          </div>
                        </>
                      )}
                      {(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") && (
                        <>
                          <div className="col-md-6 col-sm-12 col-lg-4  drive_graph mt-2 mb-2">
                            <WaterMark />
                            <RpmVsThrottle_Coral
                              title="Median RPM vs Median Throttle"
                              gloablfilter={gloablfilter}
                              apiend="rpm_vs_throttle_erc"
                            ></RpmVsThrottle_Coral>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-4 drive_graph mt-2">
                            <WaterMark />
                            <RegenPercent_Coral
                              title="Median Regen Percent"
                              gloablfilter={gloablfilter}
                              apiend="regenbar"
                            ></RegenPercent_Coral>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-4 drive_graph mt-2">
                            <WaterMark />
                            <IdlePercent_Coral
                              title="Median Idle Percent"
                              gloablfilter={gloablfilter}
                              apiend="idlebar"
                            ></IdlePercent_Coral>
                          </div>
                        </>
                      )}
                      {/* <div
                        className={
                          loggedInUser.flagForHideShow === "ERC"
                            ? "col-md-6 col-sm-4 col-lg-3 pr-1"
                            : "col-md-6 col-sm-6"
                        }
                      >
                        <WaterMark />
                        <SingleSoc
                          title="SoC Discharge/Cycle Analysis"
                          gloablfilter={gloablfilter}
                          apiend="socbar"
                        ></SingleSoc>
                      </div> */}
                      {/* <div
                        className={
                          loggedInUser.flagForHideShow === "ERC"
                            ? "col-md-6 col-sm-4 col-lg-3 pr-1"
                            : "col-md-6 col-sm-6"
                        }
                      >
                        <WaterMark />
                        <SinglePie
                          title="Mode utilization"
                          gloablfilter={gloablfilter}
                          apiend="piechart"
                        ></SinglePie>
                      </div> */}
                      {(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") && (
                        <>
                          <div className="col-md-6 col-sm-12 col-lg-4 drive_graph mt-3">
                            <WaterMark />
                            <BcsActiveTime_Coral
                              title="Median BCS Active Time"
                              gloablfilter={gloablfilter}
                              apiend="bcs_activebar"
                            ></BcsActiveTime_Coral>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-4 drive_graph mt-3">
                            <WaterMark />
                            <DischargeDuration_Coral
                              title="Median Dishcharge Duration"
                              gloablfilter={gloablfilter}
                              apiend="discharge_bar"
                            ></DischargeDuration_Coral>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-4 drive_graph mt-3">
                            <WaterMark />
                            <PieChartSocErc_Coral
                              title="Regen Mode Usage"
                              gloablfilter={gloablfilter}
                              apiend="regen_modes_pie"
                            ></PieChartSocErc_Coral>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </DashboardMain_Coral>
      </>
    );
  } else {
    return (
      <DashboardMain_Coral>
        {!(loggedInUser.flagForHideShow === "ERC" || loggedInUser.flagForHideShow === "FLEETEV") ? (
          <PageSecond_Coral gloablfilter={gloablfilter} pageChange={pageChange} />
        ) : (
          <div className="new_drive_dashboard">
            <PageSecondErc_Coral
              gloablfilter={gloablfilter}
              pageChange={pageChange}
            />
          </div>
        )}
      </DashboardMain_Coral>
    );
  }
}

export default Driveanalysis_Coral;
